var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 12.4596V7.58464L16.7917 2.16797H5.41671C5.12939 2.16797 4.85384 2.28211 4.65068 2.48527C4.44751 2.68843 4.33337 2.96398 4.33337 3.2513V22.7513C4.33337 23.0386 4.44751 23.3142 4.65068 23.5173C4.85384 23.7205 5.12939 23.8346 5.41671 23.8346H10.8334",
    stroke: "#7635DC",
    strokeWidth: 2.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4165 19.5013C19.6132 19.5013 20.5832 18.5313 20.5832 17.3346C20.5832 16.138 19.6132 15.168 18.4165 15.168C17.2199 15.168 16.2499 16.138 16.2499 17.3346C16.2499 18.5313 17.2199 19.5013 18.4165 19.5013Z",
    stroke: "#7635DC",
    strokeWidth: 2.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7499 23.8346C22.7499 22.6854 22.2934 21.5832 21.4807 20.7705C20.6681 19.9578 19.5659 19.5013 18.4166 19.5013C17.2673 19.5013 16.1651 19.9578 15.3525 20.7705C14.5398 21.5832 14.0833 22.6854 14.0833 23.8346M16.2499 2.16797V7.58464H21.6666",
    stroke: "#7635DC",
    strokeWidth: 2.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventicon);
export default __webpack_public_path__ + "static/media/eventicon.21f180b711fbba56a33ac634ec804b34.svg";
export { ForwardRef as ReactComponent };